import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Grid,
  Typography,
  Modal,
  CardContent,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import * as yup from "yup";
import { MaterialReactTable } from "material-react-table";
import EditIcon from "@mui/icons-material/Edit";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Header from "./header";
import AddIcon from "@mui/icons-material/Add";

import { apiData } from "../services/api-methods";
import { Alert, AlertTitle } from "@mui/material";

import API from "../APIUrls";
import PageDropdown from "./pageDD";
import FullPageLoader from "./loader";
import Footer from "./footer";

const validationSchema = yup.object({
  name: yup.string().required("Category Name is required"),
});

function Property() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [open, setOpen] = React.useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [tblList, setTblList] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const formik = useFormik({
    initialValues: {
      id: "",
      name: "",
      status: 1,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        let tempData;
        setLoading(true);
        setOpen(!open);

        if (values.id !== "") {
          tempData = await apiData("put", API.product, values);
        } else {
          tempData = await apiData("post", API.product, values);
        }

        if (tempData.statusCode >= 200 && tempData.statusCode < 400) {
          setMessage({ status: "success", msg: tempData.msg });
        }
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    },
  });

  async function fetchData() {
    try {
      setLoading(true);
      let tempData = await apiData("get", API.product, {
        pagination: JSON.stringify(pagination),
      });

      setTblList(tempData.data);
      setRowCount(tempData.pagination.totalCount);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, [globalFilter, pagination, columnFilters]);

  const handleEdit = (data) => {
    formik.setValues({
      id: data._id,
      name: data.name,
      status: data.status,
    });
    setOpen(!open);
  };

  const columns = useMemo(() => {
    const columns = [
      {
        header: "Category Name",
        Cell: ({ cell, row }) => row.original.name,
      },
      {
        header: "Status",
        Cell: ({ cell, row }) =>
          row.original.status === 1 ? "Active" : "In Active",
      },
      {
        header: "Edit",
        Cell: ({ cell, row }) => {
          return (
            <EditIcon
              className={`color--purple btn`}
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleEdit(row.original);
              }}
            />
          );
        },
      },
    ];

    return columns;
  }, [pagination]);

  if (loading) {
    return <FullPageLoader />;
  }
  return (
    <div className="main">
      <Header />
      {message && message.status && (
        <Alert severity={`${message.status}`} style={{ margin: "2% 10% 0%" }}>
          <AlertTitle>{message.status}</AlertTitle>
          {message.msg && <>{message.msg}</>}
        </Alert>
      )}

      <Grid className="employee-form">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Category List
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="product/add">
                Add
              </Link>
              <Typography color="text.primary">List </Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <PageDropdown page="products" />

            <Button
              size="medium"
              variant="contained"
              style={{ background: "#426e5a" }}
              className="button_first"
              onClick={() => {
                setOpen(!open);
              }}
              startIcon={<AddIcon />}
            >
              Add Category
            </Button>
          </Grid>
        </Grid>
        <CardContent className="tableCOntent" sx={{ pt: 0 }}>
          <MaterialReactTable
            columns={columns}
            data={tblList}
            // enableRowSelection
            getRowId={(row) => row.name}
            // enableColumnFilterModes
            initialState={{ showColumnFilters: false }}
            enableRowNumbers
            rowNumberMode="original"
            manualFiltering
            manualPagination
            manualSorting
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              globalFilter,
              // isLoading,
              pagination,
              // showAlertBanner: isError,
              // showProgressBars: isRefetching,
              sorting,
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              ></Box>
            )}
          />
        </CardContent>
        <Modal
          open={open}
          onClose={() => setOpen(!open)}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "background.paper",
                border: "2px solid #000",
                boxShadow: 24,
                p: 4,
              }}
              spacing={2}
            >
              <Grid item xs={12}>
                <Box component="form" noValidate autoComplete="off">
                  <FormControl className={`form-control`} fullWidth>
                    <TextField
                      name="name"
                      type="text"
                      label="Category Name"
                      onChange={formik.handleChange}
                      error={formik.touched.name && Boolean(formik.errors.name)}
                      value={formik.values.name}
                      helperText={formik.touched.name && formik.errors.name}
                      fullWidth
                    />
                  </FormControl>
                </Box>
              </Grid>

              {formik.values.id !== "" && (
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={formik.values.status}
                      name="status"
                      fullWidth
                      onChange={(e) =>
                        formik.setFieldValue("status", e.target.value)
                      }
                      error={
                        formik.touched.status && Boolean(formik.errors.status)
                      }
                      helperText={formik.touched.status && formik.errors.status}
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={2}>In Active</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={12} className="buttonContainer">
                <Button
                  variant="contained"
                  style={{ background: "#426e5a" }}
                  type="submit"
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </Modal>
      </Grid>
      <Footer />
    </div>
  );
}

export default Property;
